import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'profiles.title',
    defaultMessage: 'PROFILES',
  },
  subtitle: {
    id: 'profiles.subtitle',
    defaultMessage: 'Set viewing and editing permissions for each user profile',
  },
  addProfile: {
    id: 'profiles.addProfile',
    defaultMessage: 'Add profile',
  },
  addSimulated: {
    id: 'profiles.addSimulated',
    defaultMessage: 'Add Simulated',
  },
  simulated: {
    id: 'profiles.simulated',
    defaultMessage: 'Simulated',
  },
  views: {
    id: 'profiles.views',
    defaultMessage: 'Preview',
  },
  edition: {
    id: 'profiles.edition',
    defaultMessage: 'Edit content / skill map',
  },
  accessAssessment: {
    id: 'profiles.accessAssessment',
    defaultMessage: 'Access proof',
  },
  validateQuestions: {
    id: 'profiles.validateQuestions',
    defaultMessage: 'Validate issues',
  },
  remove: {
    id: 'profiles.remove',
    defaultMessage: 'Remove',
  },
  continue: {
    id: 'profiles.continue',
    defaultMessage: 'Continue',
  },
  cancel: {
    id: 'profiles.cancel',
    defaultMessage: 'Cancel',
  },
  profileCreatedTitle: {
    id: 'profiles.profileCreated.title',
    defaultMessage: 'Profile Created',
  },
  profileCancelTitle: {
    id: 'profiles.profileCancel.title',
    defaultMessage: 'Remove profile',
  },
  profileCreatedMessage: {
    id: 'profiles.profileCancel.message',
    defaultMessage:
      '<p> The profile <strong> {name} </strong> has been successfully created! </p> <p> An email has been sent to the address registered with the access instructions. </p>',
  },
  profileCancelMessage: {
    id: 'profiles.profileCancel.message',
    defaultMessage: '<p> Are you sure you want to remove this profile? </p>',
  },
  schools: {
    id: 'profiles.profiles.schools',
    defaultMessage: 'School',
  },
  coordinator: {
    id: 'profiles.profiles.coordinator',
    defaultMessage: 'School Coordinator',
  },
  teacher: {
    id: 'profiles.profiles.teacher',
    defaultMessage: 'School teacher',
  },
  addEvaluation: {
    id: 'profiles.addEvaluation',
    defaultMessage: 'Add evaluation',
  },
});
